import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';
import concat from 'lodash/concat';
import compact from 'lodash/compact'
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { UnsubmittedProjectCard, ActiveCard } from '../DashboardCard';
import { ProjectCard } from '../DashboardCard/ProjectCard';
import { NewProjectCard } from '../DashboardCard/NewProjectCard';
import { PastProjectCard } from '../DashboardCard/PastProjectCard';
import DashboardMessage from './DashboardMessage';
import './DashboardMain.css';

export const DashboardMain = ({
  handleSelectProject,
  handleDiscardProject,
  pendingProjects,
  pastProjects,
  unsubmittedProjects,
  overviewSteps,
  handleGoToProjectView,
  activeProjects,
  user,
  isReset,
}) => {
  const isManagerUser = includes(['Manager', 'Master'], user.type);
  const isClientUser = user.type === 'Client';
  const allProjects = compact(concat(activeProjects, pendingProjects, pastProjects))
  const [activeTab, setActiveTab] = useState("all")
  const activeTabsCount =
    [activeProjects, pendingProjects, pastProjects].filter(
      projects => !isEmpty(projects),
    ).length + 1;

  useEffect(() => {
    if (isManagerUser) {
      setActiveTab("pending")
    }
  }, []);

  const colors = ["#FFE4F3", "#FFE2A3", "#E0F198", "#DBF4F4"]

  return (
    <Fragment>
      {isReset && (
        <div className="col-12 confirm-notification on-dashbord">
          <p className="t-16">
            Success! Your account with email {user.email} has been validated.
          </p>
        </div>
      )}
      <div className={`container dashboard-container px-0 ${isReset && 'with-confirm-notification'}`}>
        <Nav
          tabs
          className="mt-3"
          style={{
            width: `${activeTabsCount * 7.25}%`,
          }}
        >
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === 'all' })}
              onClick={() => { setActiveTab('all') }}
            >
              All Projects
            </NavLink>
          </NavItem>
          { !isEmpty(activeProjects) && (
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'active' })}
                onClick={() => { setActiveTab('active') }}
              >
                Active
              </NavLink>
            </NavItem>
          )}
          { !isEmpty(pendingProjects) && (<NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'pending' })}
                onClick={() => { setActiveTab('pending') }}
              >
                Pending
              </NavLink>
            </NavItem>
          )}
          { !isEmpty(pastProjects) && (<NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'past' })}
                onClick={() => { setActiveTab('past') }}
              >
                Past
              </NavLink>
            </NavItem>
          )}
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="all">
            <div className="row mt-3 ml-0">
              { !isEmpty(allProjects) && (allProjects.map((project, index) => {
                const color = colors[project.id % 4]
                return (
                  <ProjectCard
                    color={color}
                    key={String(index)}
                    project={project}
                    handleGoToProjectView={handleGoToProjectView}
                    handleDiscardProject={handleDiscardProject}
                  />
                )
              }))}
            </div>
          </TabPane>
          <TabPane tabId="active">
            <div className="row mt-3 ml-0">
              { !isEmpty(activeProjects) && (activeProjects.map((project, index) => {
                const color = colors[project.id % 4]
                return (
                  <ProjectCard
                    color={color}
                    key={String(index)}
                    project={project}
                    handleGoToProjectView={handleGoToProjectView}
                    handleDiscardProject={handleDiscardProject}
                  />
                )
              }))}
            </div>
          </TabPane>
          <TabPane tabId="pending">
            <div className="row mt-3 ml-0">
              { !isEmpty(pendingProjects) && (pendingProjects.map((project, index) => {
                const color = colors[project.id % 4]
                return (
                  <ProjectCard
                    color={color}
                    key={String(index)}
                    project={project}
                    handleGoToProjectView={handleGoToProjectView}
                    handleDiscardProject={handleDiscardProject}
                  />
                )
              }))}
            </div>
          </TabPane>
          <TabPane tabId="past">
            <div className="row mt-3 ml-0">
              { !isEmpty(pastProjects) && (pastProjects.map((project, index) => {
                const color = colors[project.id % 4]
                return (
                  <ProjectCard
                    color={color}
                    key={String(index)}
                    project={project}
                    handleGoToProjectView={handleGoToProjectView}
                    handleDiscardProject={handleDiscardProject}
                  />
                )
              }))}
            </div>
          </TabPane>
        </TabContent>
      </div>
    </Fragment>
  );
};

DashboardMain.propTypes = {
  handleSelectProject: PropTypes.func,
  handleDiscardProject: PropTypes.func,
  pendingProjects: PropTypes.array,
  pastProjects: PropTypes.array,
  activeProjects: PropTypes.arrayOf(
    PropTypes.shape({
      project_picture: PropTypes.string,
      project_brief: PropTypes.string,
      user: PropTypes.shape({
        email: PropTypes.string,
      }),
      deadline: PropTypes.string,
      updated_at: PropTypes.string,
      drafts: PropTypes.array,
    }),
  ),
  unsubmittedProjects: PropTypes.array,
  overviewSteps: PropTypes.array,
  handleGoToProjectView: PropTypes.func,
  user: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DashboardMain/DashboardMain.js